// number of similar jobs we display at the bottom of the job details page
export const SIMILAR_JOBS_LIMIT = 9;
// number of similar jobs we display in the sidebar
export const SIDEBAR_JOBS = 4;
// number of similar jobs we display at the top with the experiment ABACUS-506
export const SIDEBAR_JOBS_NO_CONTROL_VERSION = 3;
// number of jobs we ask to the BE when we display the similar jobs at the top
export const SIMILAR_JOBS_LIMIT_NO_CONTROL_VERSION =
  SIMILAR_JOBS_LIMIT + SIDEBAR_JOBS_NO_CONTROL_VERSION;
// number of jobs we ask to the BE when similar jobs are displayed in the sidebar
export const SIDEBAR_SIMILAR_JOBS_LIMIT = SIMILAR_JOBS_LIMIT + SIDEBAR_JOBS;
